// Per-route <title> and meta description for pages that are not blog posts.
// Titles are kept to 60 characters or fewer; descriptions to 155 or fewer.
// scripts/prerender.js and scripts/seo-files.js read the route list below, so
// a route added here is prerendered and listed in sitemap.xml automatically.

export const ROUTE_SEO = {
  '/': {
    title: 'Pet Shop in Noida | Puppies, Pet Food & Accessories',
    description: 'Petsmart Puppies, Sector 31 Noida: puppies, dog food and pet accessories with guidance for new and experienced pet parents. Visit or WhatsApp us.',
  },
  '/puppies': {
    title: 'Puppies for Sale in Noida | Petsmart Puppies',
    description: 'Golden Retriever, Labrador, Shih Tzu, Husky, German Shepherd and more puppies at our Sector 31, Noida store. Ask on WhatsApp for current availability.',
  },
  '/supplies': {
    title: 'Dog Food & Pet Supplies in Noida | Petsmart Puppies',
    description: 'Puppy and dog food, treats, beds, toys, grooming and accessories at Petsmart Puppies, Sector 31 Noida. Ask on WhatsApp for brands and stock.',
  },
  '/care': {
    title: 'Puppy Care Guidance | Petsmart Puppies Noida',
    description: 'Practical puppy care guidance from Petsmart Puppies: feeding, vaccination, grooming, training and settling your new puppy at home in Noida.',
  },
  '/reviews': {
    title: 'Customer Reviews | Petsmart Puppies Noida',
    description: 'Read what pet parents say about Petsmart Puppies in Sector 31, Noida on Google and Justdial, and see photos of customers with their puppies.',
  },
  '/about': {
    title: 'About Petsmart Puppies | Pet Shop in Sector 31 Noida',
    description: 'Petsmart Puppies is a pet shop in Sector 31, Noida for puppies, dog food and accessories. Meet the store and learn how we help new pet parents.',
  },
  '/contact': {
    title: 'Contact Petsmart Puppies | Sector 31 Noida Pet Shop',
    description: 'Visit Petsmart Puppies at Shop D1, near Dr Bhimrao Ambedkar Hospital, Sector 31, Noida, call +91 72176 48679 or message us on WhatsApp.',
  },
  '/blog': {
    title: 'Puppy & Dog Care Blog | Petsmart Puppies Noida',
    description: 'Guides on puppy prices in Noida, choosing a breed, puppy care, training and feeding, written for pet parents in Noida and Delhi NCR.',
  },
  '/privacy': {
    title: 'Privacy Policy | Petsmart Puppies',
    description: 'How Petsmart Puppies collects, uses and protects personal information shared through this website, WhatsApp, phone calls and store visits.',
  },
  '/terms': {
    title: 'Terms of Use | Petsmart Puppies',
    description: 'Terms for using the Petsmart Puppies website and for enquiries about puppies, pet food and accessories at our Sector 31, Noida store.',
  },
  // Keyword landing pages (rendered by SEOLanding)
  '/puppies-in-noida': {
    title: 'Puppies in Noida | Petsmart Puppies, Sector 31',
    description: 'Looking for puppies in Noida? Visit Petsmart Puppies in Sector 31 to meet available breeds, or message us on WhatsApp for current availability.',
  },
  '/buy-puppy-noida': {
    title: 'Buy a Puppy in Noida | Petsmart Puppies',
    description: 'Planning to buy a puppy in Noida? See the breeds we usually have at our Sector 31 store and what to check before you bring a puppy home.',
  },
  '/dog-shop-noida': {
    title: 'Dog Shop in Noida | Puppies, Food & Accessories',
    description: 'Dog shop in Sector 31, Noida for puppies, dog food, treats and accessories. Visit Petsmart Puppies or ask on WhatsApp before you come.',
  },
  '/pet-store-sector-31-noida': {
    title: 'Pet Store in Sector 31 Noida | Petsmart Puppies',
    description: 'Petsmart Puppies is a pet store in Sector 31, Noida, near Dr Bhimrao Ambedkar Hospital. Puppies, dog food and pet accessories, open daily.',
  },
  '/golden-retriever-puppy-noida': {
    title: 'Golden Retriever Puppy in Noida | Petsmart Puppies',
    description: 'Golden Retriever puppies at Petsmart Puppies, Sector 31 Noida. Learn about the breed and ask on WhatsApp about current availability.',
  },
  '/shih-tzu-puppy-noida': {
    title: 'Shih Tzu Puppy in Noida | Petsmart Puppies',
    description: 'Shih Tzu puppies at Petsmart Puppies, Sector 31 Noida: an affectionate, apartment-friendly breed. Ask on WhatsApp about current availability.',
  },
  '/maltipoo-puppy-noida': {
    title: 'Maltipoo Puppy in Noida | Petsmart Puppies',
    description: 'Maltipoo puppies at Petsmart Puppies, Sector 31 Noida: a small, low-shedding cross. Ask on WhatsApp about current availability.',
  },
  '/husky-puppy-noida': {
    title: 'Husky Puppy in Noida | Petsmart Puppies',
    description: 'Siberian Husky puppies at Petsmart Puppies, Sector 31 Noida, with advice on caring for a Husky in Indian heat. Ask on WhatsApp about availability.',
  },
  '/german-shepherd-puppy-noida': {
    title: 'German Shepherd Puppy in Noida | Petsmart Puppies',
    description: 'German Shepherd puppies at Petsmart Puppies, Sector 31 Noida: intelligent, trainable and loyal. Ask on WhatsApp about current availability.',
  },
  '/labrador-puppy-noida': {
    title: 'Labrador Puppy in Noida | Petsmart Puppies',
    description: 'Labrador Retriever puppies at Petsmart Puppies, Sector 31 Noida: a gentle, family-friendly breed. Ask on WhatsApp about current availability.',
  },
  '/akita-puppy-noida': {
    title: 'Akita Puppy in Noida | Petsmart Puppies',
    description: 'Akita puppies at Petsmart Puppies, Sector 31 Noida: a loyal, dignified breed for experienced owners. Ask on WhatsApp about current availability.',
  },
};
